import React from 'react'
import PropTypes from 'prop-types'
import ComponentSelector from '../../ComponentSelector'
import Footer from '../../../containers/Footer/index'
import PageTemplate from '../../templates/PageTemplate'
import { venture } from '../../../config'
import { RemoveMargin, FontStyle } from './emailStyles'

const EmailTemplatePage = (props) => {
  const {
    components,
    globalContent,
    globalComponents,
    customTermsAndConditions
  } = props

  return (
    <PageTemplate components={components} globalContent={globalContent}>
      <FontStyle />
      <RemoveMargin />
      <ComponentSelector {...{ components, globalContent, globalComponents }} />
      <Footer
        customTermsAndConditions={customTermsAndConditions}
        venture={venture}
      />
    </PageTemplate>
  )
}
EmailTemplatePage.propTypes = {
  globalComponents: PropTypes.object,
  globalContent: PropTypes.object,
  customTermsAndConditions: PropTypes.string,
  components: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      props: PropTypes.object
    })
  )
}
export default EmailTemplatePage
